/* commandSetOsValidator.js */

/**
 * @module commandSetOsValidator
 *
 * Post-Ajv validator for the JSON edit pane. For each rule, resolves the
 * `commandSet` label to a UUID scoped by the rule's `os` — mirroring the form's
 * OS-scoped command-set dropdown — and flags it when the name is unknown for
 * that OS or matches more than one command set (ambiguous). Without this, two
 * command sets in different OS families that share a name would silently
 * resolve to the wrong UUID on save.
 *
 * Returns a function `(parsedValue, text) → errors[]` matching the shape
 * produced by json_schema_validator so the gutter-marker pipeline needs no
 * special handling. Accepts both the policy shape (`{rules:[...]}`) and a
 * single-rule shape (the rule-edit subview's JSON pane).
 */
const _ = require("lodash");
const {SchemaValidator} = require("@gluenetworks/json-editor");
const {resolveCommandSetUuid} = require("./ruleLabelMapper");

const _checkRule = (rule, basePointer, labelMaps, text, errors) => {
    if (!_.isObject(rule) || !rule.commandSet) {
        return;
    }
    const {error} = resolveCommandSetUuid(rule.commandSet, rule.os, labelMaps);
    if (!error) {
        return;
    }
    const pointer = `${basePointer}/commandSet`;
    const {line, column} = SchemaValidator.pointerToLineColumn(text, pointer);
    errors.push({line, column, message: `[commandSet] ${error}`, jsonPointer: pointer});
};

const buildCommandSetOsValidator =
    (labelMaps = {}) =>
    (parsedValue, text) => {
        if (!_.isObject(parsedValue)) {
            return [];
        }
        const errors = [];
        if (_.isArray(parsedValue.rules)) {
            parsedValue.rules.forEach((rule, idx) =>
                _checkRule(rule, `/rules/${idx}`, labelMaps, text || "", errors)
            );
        } else {
            _checkRule(parsedValue, "", labelMaps, text || "", errors);
        }
        return errors;
    };

module.exports = {buildCommandSetOsValidator};
